import {RegisterType} from '../component-registry';
import {AbstractGuidedUiElement, GuidedUiDivider} from '../../models/Guided.schema';
import {h} from '@stencil/core';
import type {GuidedV2FactoryState} from '../../models/ui';

export class GuidedV2Divider {
  @RegisterType(GuidedUiDivider.type)
  render(_data: AbstractGuidedUiElement, _state: GuidedV2FactoryState) {
      return <qds-divider></qds-divider>;
  }
}
